import { Fragment } from "react/jsx-runtime";

interface CustomULProps {
  items: string[];
}

const CustomUL = ({ items }: CustomULProps) => {
  const format = (html: string) => ({ __html: html });

  return (
    <div style={{ paddingTop: "var(--width-24)" }}>
      <div
        style={{
          borderTop: "var(--height-4) solid #fff",
          color: "#fff",
          fontFamily: "Myriad Pro",
          fontSize: "var(--width-24)",
          fontStyle: "normal",
          fontWeight: "380",
          lineHeight: "150%",
          whiteSpace: "pre-line",
          maxWidth: "var(--width-568)",
          paddingTop: "var(--width-24)",
        }}
      >
        <ul>
          {items.map((item, index) => (
            <Fragment>
              <li key={index} dangerouslySetInnerHTML={format(item)}></li>
              {items.length - 1 !== index && <br />}
            </Fragment>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CustomUL;
